/**
 * Uplifted from apps/web/src/redux-store/slices/common.ts +
 * apps/mobile/src/reduxStore/slices/common.ts.
 *
 * The two were RUNTIME-IDENTICAL: `fetchCommonData`'s reducer body is empty `{}` — the
 * action exists only as a signal for `commonSaga`'s `takeEvery`, which reads the payload
 * and makes the API call. Same `name`, same action type, same (empty) state. So shared.ts
 * owns the whole slice and the platform files re-export; see KeyBoardShortcuts/shared.ts.
 *
 * The apps differed in exactly two ways, neither observable at runtime:
 *   - param names, `(state, action)` on web vs `(_state, _action)` on mobile. Unified to
 *     the underscore form, which is what "deliberately unused" should look like.
 *   - `skipGlobalLoader?: boolean`, present on web's local `CommonAction`, absent on
 *     mobile's. Kept — see below.
 */
import { createSlice } from "@reduxjs/toolkit";

interface CommonAction {
  payload: {
    method: string;
    url: string;
    body?: any;
    action?: any;
    callback?: any;
    errorCallback?: boolean;
    hideLoader?: boolean;
    /**
     * WEB ONLY at present. `apps/web`'s commonSaga forwards this to `api.request`, where
     * `utils/apiService` uses it to suppress the global loader; `apps/mobile`'s commonSaga
     * does not forward it, so passing it from mobile is silently ignored.
     *
     * Typed here for both because the type is erased and the field is optional — this
     * widens mobile's accepted payload but changes no behaviour, and the alternative is
     * two `createSlice` calls kept in sync by hand for a slice whose runtime is identical.
     * Delete this note when mobile's commonSaga forwards it too.
     */
    skipGlobalLoader?: boolean;
  };
  type: string;
}

const initialState = {};

export const commonSlice = createSlice({
  name: "common",
  initialState,
  reducers: {
    fetchCommonData: (_state, _action: CommonAction) => {},
  },
});
export const { fetchCommonData } = commonSlice.actions;
export default commonSlice.reducer;
